<template>
  <div class="content">
    <div class="about">
      <!-- <p class="title" :style="{ color: textColor }" id="title">{{ title }}</p> -->
       <div class="title">{{ $store.state.data.logo_name }}</div>
      <div class="desc">
        <div v-for="(item, index) in desc" :key="index">
          <ul v-if="item.type === 'list'">
            <li v-for="(list, index) in item.text" :key="index">
              {{ index + 1 }}. {{ list }}
            </li>
          </ul>
          <span v-else>{{ item.text }}</span>
        </div>
      </div>
      <div class="features">
        <div class="title">Key Features</div>
        <ul>
          <li><svg t="1762764406827" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2422" width="200" height="200"><path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c0.096 0.096 0.224 0.128 0.32 0.224 0.096 0.096 0.128 0.224 0.224 0.32 2.016 1.92 4.448 3.008 6.784 4.288 1.152 0.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-0.832 12.288-2.496 1.312-0.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672 0.096-0.096 0.128-0.256 0.224-0.352 0.064-0.096 0.192-0.128 0.288-0.224l449.184-478.208C901.44 330.592 900.768 310.336 887.904 298.208z" p-id="2423" fill="#adb7be"></path></svg>AI Generation: Text-to-Image, Image-to-Image, Text-to-Video, and Image-to-Video.</li>
          <li><svg t="1762764406827" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2422" width="200" height="200"><path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c0.096 0.096 0.224 0.128 0.32 0.224 0.096 0.096 0.128 0.224 0.224 0.32 2.016 1.92 4.448 3.008 6.784 4.288 1.152 0.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-0.832 12.288-2.496 1.312-0.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672 0.096-0.096 0.128-0.256 0.224-0.352 0.064-0.096 0.192-0.128 0.288-0.224l449.184-478.208C901.44 330.592 900.768 310.336 887.904 298.208z" p-id="2423" fill="#adb7be"></path></svg><van-icon name="success" />Advanced AI Models: Integrates Nano Banana, PixVerse, Seedream, and more for top-tier results.</li>
          <li><svg t="1762764406827" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2422" width="200" height="200"><path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c0.096 0.096 0.224 0.128 0.32 0.224 0.096 0.096 0.128 0.224 0.224 0.32 2.016 1.92 4.448 3.008 6.784 4.288 1.152 0.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-0.832 12.288-2.496 1.312-0.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672 0.096-0.096 0.128-0.256 0.224-0.352 0.064-0.096 0.192-0.128 0.288-0.224l449.184-478.208C901.44 330.592 900.768 310.336 887.904 298.208z" p-id="2423" fill="#adb7be"></path></svg><van-icon name="success" />Text & Image to Video: Magically turn your prompts or pictures into dynamic videos.</li>
          <li><svg t="1762764406827" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2422" width="200" height="200"><path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c0.096 0.096 0.224 0.128 0.32 0.224 0.096 0.096 0.128 0.224 0.224 0.32 2.016 1.92 4.448 3.008 6.784 4.288 1.152 0.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-0.832 12.288-2.496 1.312-0.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672 0.096-0.096 0.128-0.256 0.224-0.352 0.064-0.096 0.192-0.128 0.288-0.224l449.184-478.208C901.44 330.592 900.768 310.336 887.904 298.208z" p-id="2423" fill="#adb7be"></path></svg><van-icon name="success" />Versatile Art Styles: Explore over 90 unique styles and AI filters to craft the perfect image.</li>
          <li><svg t="1762764406827" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2422" width="200" height="200"><path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c0.096 0.096 0.224 0.128 0.32 0.224 0.096 0.096 0.128 0.224 0.224 0.32 2.016 1.92 4.448 3.008 6.784 4.288 1.152 0.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-0.832 12.288-2.496 1.312-0.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672 0.096-0.096 0.128-0.256 0.224-0.352 0.064-0.096 0.192-0.128 0.288-0.224l449.184-478.208C901.44 330.592 900.768 310.336 887.904 298.208z" p-id="2423" fill="#adb7be"></path></svg><van-icon name="success" />Vast Template Library: Get inspired with 500+ templates for quick and amazing creations.</li>
          <li><svg t="1762764406827" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2422" width="200" height="200"><path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c0.096 0.096 0.224 0.128 0.32 0.224 0.096 0.096 0.128 0.224 0.224 0.32 2.016 1.92 4.448 3.008 6.784 4.288 1.152 0.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-0.832 12.288-2.496 1.312-0.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672 0.096-0.096 0.128-0.256 0.224-0.352 0.064-0.096 0.192-0.128 0.288-0.224l449.184-478.208C901.44 330.592 900.768 310.336 887.904 298.208z" p-id="2423" fill="#adb7be"></path></svg><van-icon name="success" />Batch Processing: Save time by generating multiple images and videos at once.</li>
          <li><svg t="1762764406827" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2422" width="200" height="200"><path d="M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696C170.208 511.872 149.952 512 137.536 524.608c-12.416 12.576-12.256 32.864 0.352 45.248l256.48 252.672c0.096 0.096 0.224 0.128 0.32 0.224 0.096 0.096 0.128 0.224 0.224 0.32 2.016 1.92 4.448 3.008 6.784 4.288 1.152 0.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-0.832 12.288-2.496 1.312-0.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672 0.096-0.096 0.128-0.256 0.224-0.352 0.064-0.096 0.192-0.128 0.288-0.224l449.184-478.208C901.44 330.592 900.768 310.336 887.904 298.208z" p-id="2423" fill="#adb7be"></path></svg><van-icon name="success" />Reliable: 24/7 non-stop service for all your creative needs.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      desc: [],
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      const { title, desc } = config.page[1];
      this.title = title;
      this.desc = desc;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  // padding: 10px 0;
  flex: 1;
  // background-image: url("~@/assets/images/about.png");
  // background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .about {
    // max-width: 960px;
    // transform: translateX(36%);
    // width: 54%;
    max-width: 800px;
    .title {
      font-size: 33px;
      font-family: "Momo Trust Display", Poppins, PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 46px;
      text-align: center;
    }
    .desc {
      // width: 80%;
      line-height: 24px;
      color: #adb7be;
      div {
        margin-bottom: 15px;
      }
      ul {
        margin-top: 10px;
      }
      ul li {
        margin-left: 20px;
        font-size: 18px;
      }
    }
  }
}
.content .about .features{
  .title{
    text-align: left;
    font-size: 16px;
    font-family: Poppins, PingFangSC-Regular, PingFang SC;
    color: #d7d7d7;
    margin-bottom: 0;
  }
  ul{
    margin-top: 0;
    padding-left: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    li{
      color: #adb7be;
      list-style: none;
      font-size: 14px;
      display: flex;
      align-items: center;
      ::v-deep{
        svg{
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
